import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  provideSolAuthentication,
  provideSolComponents,
  provideSolDebug,
  provideSolHttpClient,
  provideSolLocale,
  provideSolNavigation,
  provideSolStorage,
  provideSolTheme,
  Theme,
} from '@sol/components';
import { environment } from '../environments/environment';
import * as packageJson from '../../package.json';
import { apps } from './apps';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    ...provideSolHttpClient(),
    provideSolComponents(packageJson.version),
    provideSolDebug(environment.ENV),
    // Keycloak only when the environment supplies a URL; local builds stay auth-free.
    ...(environment.KEYCLOAK_URL
      ? [
          provideSolAuthentication({
            url: environment.KEYCLOAK_URL,
            realm: environment.KEYCLOAK_REALM,
            clientId: environment.KEYCLOAK_CLIENT_ID,
          }),
        ]
      : []),
    provideSolStorage(environment.APP),
    provideSolTheme(Theme.SOL_DARK),
    provideSolNavigation(apps, routes, environment),
    provideSolLocale(['sol-playground', 'sol-components']),
  ],
};
